import React, { useState } from "react";

import { RegulatorySearchFilterType } from "@/components/business/RegulatoryContainer/regulatoryList.types";

import { REGULATORY_LIST_EDITOR_INFO_FILTER } from "./components/RegulatoryEditorInfoSearch/constants/editorInfoFilter.constants";
import CtgListEditorInfoSearch from "./components/RegulatoryEditorInfoSearch/RegulatoryEditorInfoSearch";
import { REGULATORY_LIST_INFO_FILTER } from "./components/RegulatoryPressInfoSearch/constants/pressInfoFilter.constants";
import CtgListPressInfoSearch from "./components/RegulatoryPressInfoSearch/RegulatoryPressInfoSearch";
import * as S from "./RegulatorySearch.style";

const RegulatorySearch = () => {
  const [currentRegulatoryFilter, setCurrentRegulatoryFilter] =
    useState<RegulatorySearchFilterType>(REGULATORY_LIST_INFO_FILTER[0]);
  const [currentEditorFilter, setCurrentEditorFilter] =
    useState<RegulatorySearchFilterType>(REGULATORY_LIST_EDITOR_INFO_FILTER[0]);

  return (
    <S.SearchWrapper>
      <CtgListPressInfoSearch
        currentPressFilter={currentRegulatoryFilter}
        setCurrentFilter={setCurrentRegulatoryFilter}
      />
      <CtgListEditorInfoSearch
        currentEditorFilter={currentEditorFilter}
        setCurrentFilter={setCurrentEditorFilter}
      />
    </S.SearchWrapper>
  );
};

export default RegulatorySearch;
